<div class="px-4 py-5 my-5 text-center">
  <h1 style="color: var(--secondary-color)" class="display-5 fw-bold ">¿Tienes alguna duda?</h1>
  <div class="col-lg-6 mx-auto">
    <p style="color: var(--secondary-color)" class="display-6 lead mb-4">Contáctanos al:</p>
  </div>

  <div class="container text-center mw-50">
    <div class="row align-items-center">
      <div class="col-4 col-sm-4 mx-auto" *ngFor="let item of sucursales ">
        <h4 style="color: var(--primary-color)" class=" fs-5 text-center"><i style="color: var(--terciary-color)" class="bi bi-geo-alt-fill"></i> {{ item.name }} </h4>
        <h4 style="color: var(--primary-color)" class=" fs-5 text-center my-4"><i style="color: var(--terciary-color)" class="bi bi-telephone-fill "></i> {{ item.numberPhone }} </h4>
      </div>

    </div>
    <div class="container text-center my-4 mw-50">
      <div class="col-12">
        <h4 style="color: var(--primary-color)" class=" fs-5"><i style="color: var(--terciary-color)" class="bi bi-whatsapp "></i> 0993183975 </h4>
      </div>
    </div>
  </div>

  <div class="container text-center">
    <div class="row ">
      <div class="col text-center">
        <h4 style="color: var(--primary-color)" class=" fs-5"><i style="color: var(--terciary-color)" class="bi bi-envelope-at "></i> contactcenter&#64;medilink.com.ec </h4>
      </div>
      <div class="col text-center">
        <h4 style="color: var(--primary-color)" class=" fs-5"><i style="color: var(--terciary-color)" class="bi bi-envelope-at "></i> comercial&#64;medilink.com.ec </h4>
      </div>
    </div>
  </div>
</div>
